import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { Base_URL } from "../../Common/Path";
import { redirectToLogin } from "../../Common/redirectToLogin";
import { secureTokenManager } from "../../utils/secureTokenManager";

let refreshTokenInterval = null;

const refreshTokenDirectCall = async () => {
  try {
    const storedRefreshToken = secureTokenManager.getRefreshToken();
    if (!storedRefreshToken) {
      secureTokenManager.clearTokens();
      redirectToLogin();
      return;
    }

    const response = await axios.post(`${Base_URL}/auth/refresh`, { refreshToken: storedRefreshToken });
    
    if (response.status === 201) {
      const newAccessToken = response.data?.data?.accessToken;
      const currentRefreshToken = secureTokenManager.getRefreshToken();
      secureTokenManager.setTokens(newAccessToken, currentRefreshToken);
    } else {
      secureTokenManager.clearTokens();
      redirectToLogin();
    }
  } catch (error) {
    localStorage.clear();
    redirectToLogin();
  }
};

export const UserSignIn = createAsyncThunk(
  "UserSignIn",
  async (body, thunkAPI) => {
    try {
      const response = await axios.post(`${Base_URL}/auth/signin`, body);
      const { accessToken, refreshToken } = response.data;
      thunkAPI.dispatch({
        type: "user/setAuthDetails",
        payload: { token: accessToken, email: body.email, refreshToken },
      });

      clearInterval(refreshTokenInterval);
      refreshTokenInterval = setInterval(() => {
        refreshTokenDirectCall();
      }, 600000);

      return { responseData: response.data, requestBody: body };
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        redirectToLogin();
      }
      // Use rejectWithValue to pass error message to the component
      return thunkAPI.rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);

export const LogOut = createAsyncThunk("LogOut", async (payload, thunkAPI) => {
  clearInterval(refreshTokenInterval);
  localStorage.clear();
  localStorage.removeItem('lastActivity');
  thunkAPI.dispatch({
    type: "user/clearAuthDetails",
  });
  return payload;
});
